module.exports = __webpack_public_path__ + "static/media/weeklyTravelTime.be7986a2.png";